import { Group } from "../../types/group/group.type";

export default class GroupUtil {
  private group: Group;

  constructor(group: Group) {
    this.group = group;
  }


  /**
   * @description Check if the user has admin access to the group
   */
  public hasAdminAccess(): boolean {
    return this.group && this.group.myRole === 'admin'
  }

  /**
   * @description Check if the user has moderator access to the group
   */
  public hasModeratorAccess(): boolean {
    return this.group && this.group.myRole === 'moderator'
  }

  /**
   * @description Check if the user has member access to the group
   */
  public hadMemberAccess(): boolean {
    return this.group && this.group.myRole === 'user'
  }

  /**
   * @description Check if the user has any access to the group
   */
  public hasAnyAccess(): boolean {
    return this.hasAdminAccess() || this.hasModeratorAccess() || this.hadMemberAccess()
  }

  /**
   * @description Check group joined status
   */
  private isJoined(): boolean {
    return this.group && this.group.joinStatus === "joined"
  }

  /**
   * @description Check if group is open
   */
  public isOpen(): boolean {
    return this.group && this.group.groupType === "open"
  }

  /**
   * @description Check if group is closed
   */
  public isClosed(): boolean {
    return this.group && this.group.groupType === "closed-free"
  }


  /**
   * @description Check if the user can access the tabs or group resource
   */

  /**
   * @description Check if the user can access the section or group resource
   * This can only check of group not section access
   */
  public hasReadAccess(): boolean {
    return this.hasAnyAccess() || this.isJoined();
  }


}